<template>
    <div class="scroll-content-horizonal section-group" ref="scrollContent">
        <GroupNode 
            v-for="(item, index) in list"
            @handleExpand="handleExpand"
            @handleChecked="handleChecked"
            :data="item"
            :key="index"
            :withMembers="withMembers"/>
        <Load 
      		:hasData="!!list.length"
            :hasMore="hasMore"
			:loading="loading" 
			@on-load="getGroupList"/>
        <Empty v-if="!loading && !hasMore && !list.length"/>
    </div>
</template>
<script>
    /**
     * 内部群
     *  */
    import GroupNode from './section-group-node'
    import scroll from '../mixins/scroll'
    import section from '../mixins/section'
    import ajax from '../../../../utils/ajax'
    import Empty from '../../../base/empty/'
    import Message from '../../../base/message/'
    import { t } from '../../../../locale/'

    export default {
        name: 'SectionGroup',
        mixins: [scroll, section],
        inject: ['root'],
        props: {
            withMembers: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                size: 20
            }
        },
        components: {
            GroupNode,
            Empty
        },
        methods: {
            getGroupList(deptId) { // 拉取当前内部群
                const _this = this
                this.loading = true
                ajax({
                    url: `${this.root.host}/cooperation/rest/v1/candidate/${this.root.qzId}/groups`,
                    params: {
                        keyword: '',
                        page: _this.page,
                        size: _this.size,
                        language: _this.root.language
                    },
                    success(res) {
                        let data = JSON.parse(res)
                        if(!Array.isArray(data)) {
                            return _this.handleError()
                        }
                        data.forEach(item => {
                            item.expand = false
                            item.checked = false
                            item.loading = false
                            item.children = []
                        })
                        _this.hasMore = !(data.length < _this.size)
                        _this.page++
                        _this.loading = false
                        return _this.list = _this.list.concat(data)
                    },
                    error() {
                        _this.handleError()
                    }
                })
            },
            getMemberList(groupId, params, isSelect) { // 拉取当前内部群成员
                const _this = this
                params && (params.loading = true)
                ajax({
                    url: `${this.root.host}/cooperation/rest/v1/candidate/${this.root.qzId}/group/${groupId}/members`,
                    params: {
                        token: '832eb293-8e5f-486f-a3be-057900b10b7b',
                        keyword: '',
                        page: 1,
                        size: 300,
                        language: _this.root.language,
                        tmp: new Date().valueOf()
                    },
                    success(res) {
                        let data = JSON.parse(res)
                        if(!(data && data.length)) {
                            return _this.handleError(params)
                        }
                        data.forEach(item => {
                            item.checked = !!isSelect || false
                            if(isSelect) {
                                _this.$emit('handleSelected', item)
                            }
                        })
                        params && (params.loading = false)
                        params && (params.children = data)
                    },
                    error() {
                        _this.handleError(params)
                    }
                })
            },
            handleChecked(checked, data) {
                if(data.loading) return
                if(!this.withMembers || data.type === 0) {
                    if(checked && 1 + this.root.selectedCount > this.root.limit) {
                        return Message.warning(t('selectMember.maximum'))
                    }
                    data.checked = checked
                    return this.$emit('handleSelected', data)
                } 
                if(checked && data.groupMemberCount + this.root.selectedCount > this.root.limit) {
                    return Message.warning(t('selectMember.maximum'))
                }
                if(data.children && data.children.length) {
                    data.checked = checked
                    return data.children.forEach((item)=>{
                        item.checked = checked
                        this.$emit('handleSelected', item)
                    })
                } 
                data.expand = true
                return this.getMemberList(data.gid, data, true)
            },
            handleExpand(expand, data) {
                data.expand = expand
                if(data.children && data.children.length) return
                this.getMemberList(data.gid, data)
            }
        },
        created() {
            this.getGroupList()
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/business/select-member/section/section-group.vue